enum Shadows {
	Lg = '0 4px 6px -1px #0000001a ',
	Md = '0 1px 3px 0 #0000001a ',
	Sm = '0 1px 2px 0 #0000000d ',
	Xl = '0 10px 15px -3px #0000001a ',
}

export default Shadows;
